import { render } from "./ActiveCompetitions.vue?vue&type=template&id=5dbf6bec"
import script from "./ActiveCompetitions.vue?vue&type=script&lang=js"
export * from "./ActiveCompetitions.vue?vue&type=script&lang=js"
script.render = render

export default script